
import { ref } from "@vue/reactivity";
import { onMounted } from "@vue/runtime-core";
import { getReportList } from "@/api/http";
export default {
  components: {},
  setup() {
    const reportList = ref<any>([]);
    const showModal = (type: number) => {
      document.dispatchEvent(new CustomEvent("show_modal", { detail: type }));
    };
    onMounted(() => {
      getReportList().then((data) => {
        if (data.code === "0") {
          reportList.value = data.data
            .map((item: any) => {
              return { ...item, no: item.no * 1 };
            })
            .filter((item: any) => item.title === "茶饮料");
        }
      });
    });
    return {
      reportList,
      showModal,
    };
  },
};
